import { Colors } from '@chakra-ui/theme';

const colors: Colors = {
  primary: {
    500: '#1F2937',
  },
  amatrium: {
    100: '#E6E5E3',
    200: '#745767',
    300: '#627457',
    500: '#E6E5E3',
    600: '#F3F2F0',
    700: '#F4F3F0',
    800: '#868584',
    900: '#424242',
  },
  analyze: {
    100: '#E8DAF3',
    200: '#F0F3DA',
    300: '#181818',
    400: '#34688A',
    500: '#60657C',
    600: '#6B7280',
  },
  grey: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  amatrium_border: '#E5E7EB',
  main_color: '#7963FF',
  main_summary_color: '#10a37f',
  sub_main_color: '#cfe018',
};

export default colors;
